import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { ProgramSettingsPage } from './program-settings-page';
import { PagesModule } from 'pages/pages.module';

@NgModule({
    declarations: [ProgramSettingsPage],
    imports: [PagesModule, ComponentsModule],
    exports: [ProgramSettingsPage]
})
export class ProgramSettingsPageModule { }